import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const CopyIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M3.85714 0.771429V0C3.43109 0 3.08571 0.34538 3.08571 0.771429H3.85714ZM3.85714 14.1429H3.08571C3.08571 14.5689 3.43109 14.9143 3.85714 14.9143V14.1429ZM17.2286 14.1429V14.9143C17.6546 14.9143 18 14.5689 18 14.1429H17.2286ZM12.6 5.25974H11.8286C11.8286 5.68579 12.174 6.03117 12.6 6.03117V5.25974ZM12.6 0.771429L13.137 0.21762L12.9126 0H12.6V0.771429ZM17.2286 5.25974H18V4.93323L17.7656 4.70593L17.2286 5.25974ZM0.771429 3.85714V3.08571C0.34538 3.08571 0 3.43109 0 3.85714H0.771429ZM0.771429 17.2286H0C0 17.6546 0.34538 18 0.771429 18L0.771429 17.2286ZM14.1429 17.2286V18C14.5689 18 14.9143 17.6546 14.9143 17.2286H14.1429ZM3.85714 0.771429H3.08571V14.1429H3.85714H4.62857V0.771429H3.85714ZM3.85714 14.1429V14.9143H17.2286V14.1429V13.3714H3.85714V14.1429ZM12.6 5.25974H13.3714V0.771429H12.6H11.8286V5.25974H12.6ZM12.6 0.771429V0H3.85714V0.771429V1.54286H12.6V0.771429ZM17.2286 14.1429H18V5.25974H17.2286H16.4571V14.1429H17.2286ZM17.2286 5.25974V4.48831H12.6V5.25974V6.03117H17.2286V5.25974ZM17.2286 5.25974L17.7656 4.70593L13.137 0.21762L12.6 0.771429L12.063 1.32524L16.6915 5.81355L17.2286 5.25974ZM0.771429 3.85714H0V17.2286H0.771429H1.54286V3.85714H0.771429ZM0.771429 17.2286V18H14.1429V17.2286V16.4571H0.771429V17.2286ZM3.85714 3.85714V3.08571H0.771429V3.85714V4.62857H3.85714V3.85714ZM14.1429 17.2286H14.9143V14.1429H14.1429H13.3714V17.2286H14.1429Z"
      fill={color}
    />
  </Svg>
);

CopyIcon.displayName = 'CopyIcon';
